export const FIRE_DEPARTMENT_IDS = {
  AL: {
    BIRMINGHAM: "F1404",
    HOMEWOOD: "F1405",
  },
  AZ: {
    GILBERT: "F3980",
  },
  ID: {
    IDAHO_FALLS: "F3848",
  },
  KS: {
    LENEXA_FIRE_DEPARTMENT: "F10910",
    KANSAS_CITY_KANSAS_FIRE_DEPT: "F9408",
  },
  MD: {
    HOWARD_COUNTY: "F6534",
  },
  OH: {
    CLEVELAND_FIRE_DEPARTMENT: "F22321",
    WADSWORTH_FIRE_DEPARTMENT: "F20662",
  },
  TX: {
    PLANO_FIRE_RESCUE: "F25531",
  },
  VA: {
    NEWPORT_NEWS_FIRE_DEPARTMENT: "F23231",
  },
};

export const LEPC_IDS = {
  AK: {
    ANCHORAGE: "71",
  },
  AL: {
    MORGAN: "2381",
  },
  CA: {
    AMADOR: "65",
    ALAMEDA: "29",
    BAKERSFIELD: "148",
    BERKELEY_CITY: "233",
    FREMONT: "1212",
    HEALDSBURG_SEBASTOPOL: "1518",
    LIVERMORE_PLEASANTON: "2002",
    LOS_ANGELES_COUNTY: "2035",
    MADERA: "2077",
    PETALUMA: "2698",
    RIVERSIDE: "2927",
    SANTA_CLARA: "3041",
    SANTA_CRUZ: "3043",
    SANTA_FE_SPRINGS: "3045",
    SANTA_MONICA: "3046",
    SAN_BERNARDINO_COUNTY: "3014",
    SAN_DIEGO_COUNTY: "3015",
    SAN_FRANCISCO: "3016",
    SAN_JOAQUIN: "3018",
    SUNNYVALE: "3315",
    UNION_CITY: "3457",
    VENTURA: "3500",
  },
  IL: {
    WILL_COUNTY: "3715",
  },
  IN: {
    ALLEN_COUNTY: "53",
  },
  KS: {
    FORD_COUNTY: "1161",
  },
  LA: {
    EAST_BATON_ROUGE: "999",
    RAPIDES_PARISH: "2868",
  },
  MD: {
    MONTGOMERY: "2362",
  },
  MI: {
    KALAMAZOO_COUNTY: "1754",
  },
  NC: {
    ALAMANCE_COUNTY: "28",
    WAKE_COUNTY: "3523",
    MECKLENBURG_COUNTY: "2222",
    MONTGOMERY_COUNTY: "2356",
    ONSLOW_COUNTY: "2580",
  },
  NJ: {
    HOWELL_TOWNSHIP: "1605",
  },
  NY: {
    NYC: "2468",
    ORANGE_COUNTY: "2585",
  },
  SC: {
    RICHLAND_COUNTY: "2905",
    DORCHESTER_COUNTY: "958",
  },
  OH: {
    WARREN_COUNTY: "3555",
    HAMILTON_COUNTY: "1409",
  },
  OR: {
    MULTNOMAH_COUNTY: "2416",
  },
  PA: {
    BERKS_COUNTY: "238",
    CENTRE_COUNTY: "533",
    CITY_OF_PHILADELPHIA: "632",
    CRAWFORD_COUNTY: "804",
    MONTGOMERY_COUNTY: "2357",
    POTTER_COUNTY: "2795",
    WASHINGTON_COUNTY: "3582",
  },
  WA: {
    CITY_OF_KENT: "627",
    CITY_OF_SEATTLE: "638",
    JBLM: "1742",
  },
  TX: {
    JEFFERSON_COUNTY: "1713",
  },
  UT: {
    DAVIS_COUNTY: "871",
    SALT_LAKE_CITY: "3009",
    TOOELE_COUNTY: "3400",
    UTAH_COUNTY: "3480",
  },
  VA: {
    BOTETOURT_COUNTY: "306",
    CAROLINE_COUNTY: "481",
    CRAIG_COUNTY: "793",
    FAIRFAX_COUNTY: "1102",
    FREDERICKSBURG: "624",
    HENRICO_COUNTY: "1530",
    KING_GEORGE_COUNTY: "1799",
    LYNCHBURG: "628",
    MECKLENBURG_COUNTY: "2223",
    PENINSULA_JOINT_LEPC: "2672",
    PRINCE_WILLIAM_COUNTY: "2817",
    RICHMOND: "636",
    ROANOKE_VALLEY_JOINT: "2932",
    SPOTSYLVANIA_COUNTY: "3211",
    STAFFORD_COUNTY: "3244",
  },
};
